import { render } from "./permissionPopup.vue?vue&type=template&id=314e96de&scoped=true"
import script from "./permissionPopup.vue?vue&type=script&lang=js"
export * from "./permissionPopup.vue?vue&type=script&lang=js"

import "./permissionPopup.vue?vue&type=style&index=0&id=314e96de&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314e96de"]])

export default __exports__